import type { VideoEmbed } from '~~/entities/embeds'
import type { APIBodyParams, VideoEmbedAPIQueryParams } from '~~/entities/api'

export function useCompanyEmbedVideos(companyId: string | number) {
  const baseUrl = `/v2/companies/${companyId}/embed/videos`

  const {
    createItem: createCompanyEmbedVideo,
    listItemsPaginated: listCompanyEmbedVideos,
    getItem: getCompanyEmbedVideo,
    updateItem: updateCompanyEmbedVideo,
    deleteItem: deleteCompanyEmbedVideo,
  } = useAPIClient<VideoEmbed, VideoEmbedAPIQueryParams, APIBodyParams>(baseUrl)

  return {
    createCompanyEmbedVideo,
    listCompanyEmbedVideos,
    getCompanyEmbedVideo,
    updateCompanyEmbedVideo,
    deleteCompanyEmbedVideo,
  }
}
